var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header'),_c('iframe',{staticClass:"users-v2-iframe",attrs:{"src":_vm.usersV2Url,"title":"Manage Users V2","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }